import type { UserPageLocationState } from '@user/pages/UserPageLocationState';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

export const useLoginErrorMessage = (): string | null => {
  const { t } = useTranslation();
  const location = useLocation() as { state?: UserPageLocationState };

  if (location.state?.loginFailed) {
    return t('auth.login.processingFailed');
  }

  if (location.state?.userNotFound) {
    return t('auth.login.userNotFound');
  }

  return location.state?.loginErrorMessage || null;
};
